import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import socket from "../../../Socket";
import storage from "../../../Storage";
import { decode, encode, getElement, sendNotfication, isEmail, Event, DEVELOPMENT, wait, randomString } from "../../../Helper";
import C from "../../../Constant";
import axios from 'axios';
import { Link } from 'react-router-dom';
import Adjust from "@adjustcom/adjust-web-sdk";


const StyledModal = styled(Modal)`
   .modal-content {
    background-color: rgb(35 38 38);
    color: white;
    border-radius: 18px;
    overflow: hidden;
    display:flex;
    flex-direction:row;

    @media(max-width:340px){
      margin:5px !important;
    }
  }
    .modal-md{
    @media(min-width:640px){
      max-width:50rem !important;
    }
    }  
`;

const ModalHeader = styled.div`
  background-color transparent;
  // padding: 10px;
  padding-left:15px;
  padding-right:15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;

  @media(max-width:640px){
  display:none;
  }
`;

const ModalBody = styled(Modal.Body)`
@media(max-width:400px){
  padding:0px;
  padding-top:10px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const StyledInput = styled.input`
  background-color: #1E2121;
  border: 1px solid #3A4142;
  border-radius: 7px;
  color: white;
  padding: 7px;
  font-size:clamp(5px,3vw,12px);
  &::placeholder {
    color: #9CA3AF;
    font-weight:500;
  }
  &:focus {
    outline: none;
    border-color: #83EA77;
    box-shadow: 0 0 0 0.5px #83EA77;
  }
`;

const StyledInputss = styled.input`
  background-color: #1E2121;
  border: 1px solid #3A4142;
  border-radius: 7px;
  color: white;
  padding: 7px;
  font-size:clamp(5px,3vw,12px);
  &::placeholder {
    color: #9CA3AF;
    font-weight:500;
  }
  &:focus {
    outline: none;
    border-color: #83EA77;
    box-shadow: 0 0 0 0.5px #83EA77;
  }
    flex: 1;
    padding-right: 110px; /* to give room for the button inside */
    height: 40px;
`;

const Labeltext = styled.div`
  color: #696F79;
  font-size: 14px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const Button = styled.button`
   padding: 10px 20px;
  border-radius: 7px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const SignUpButton = styled(Button)`
   background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
  color: black;
  border: none;
  width: 100%;
  max-width: 100%;
  max-height:100%;
  margin-top:10px;

  &:hover {
    background-color: #7c3aed;
  }
`;
// const SendOtpButton  = styled(Button)`
//    background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
//     box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
//     color: black;
//     border: none;


//   &:hover {
//     background-color: #7c3aed;
//   }
// `;
const SendOtpButton = styled.button`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    padding: 0 10px;
    font-size: 0.9rem;
    border: none;
    color: black;
    border-radius: 4px;
    cursor: pointer;
     background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
`;

const SignInButton = styled(Button)`
    color: rgb(36 238 137);
  background:transparent;
  border:none;
`;

const StyledSignUpButton = styled.div`

  background-color: #45B70C;
  color: white;
  border: none;
  border-radius: 500px;
  padding: 10px 24px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space:nowrap;

 
`;

const CloseButtonNew = styled.div`
position:absolute;
top:10px;
right:10px;
font-size:18px;
display:none;

@media(max-width:640px){
display:block;
}
`

const PhoneInputWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;



class NewRegister extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogged: storage.getKey('logged'),
            show: this.props.show ? this.props.show : false,
            username: '',
            phone: '',
            email: '',
            password: '',
            confirmPassword: '',
            referral: this.props.referral || '',
            ruleChecked: false,
            ruleChecked18: false,
            submitted: false,
            disabled: false,
            effect: 'zoomIn',
            isOtp: false,
            otp: '',
            loading: false,
            countryCode: "+977",
            countryCodeData: [],
            submitted: false,
            isLoading: false,
        };
    }

    componentDidMount() {
        this.countryCodeLoad();
        socket.on(C.REGISTER_USER, data => this.setRegister(decode(data)));
        Event.on('register_form', () => {
            this.handleShow();
        });
    }

    countryCodeLoad = async () => {
        try {
            const response = [
                {
                    "name": "Nepal",
                    "dial_code": "+977",
                    "code": "NP",
                    "flag": "🇳🇵"
                },
                {
                    "name": "Pakistan",
                    "dial_code": "+92",
                    "code": "PK",
                    "flag": "🇵🇰"
                },
                {
                    "name": "Bangladesh",
                    "dial_code": "+880",
                    "code": "BD",
                    "flag": "🇧🇩"
                }
            ];
            this.setState({ countryCodeData: response });
        } catch (error) {
            console.error("Error fetching country codes:", error);
        }
    };

    setRegister = (data) => {
        console.log(data)
        if (data.error) {
            this.setState({ disabled: false, submitted: false, isLoading: false });
            return sendNotfication(data.error, 'success', 'bottom-left');
        }

        if (data.status) {

            // fbq('track', 'CompleteRegistration');

            if (window.fbq) {
                fbq("track", "CompleteRegistration");
            }

            if (window.Adjust) {
                Adjust.trackEvent("5osc2h"); // signup
            }

            console.log("datataaaa", data)
            this.setState({ submitted: false, isLoading: false });
            wait(1000).then(() => {
                socket.emit(C.LOGIN_USER, encode({
                    username: data.name,
                    password: data.password,
                    recaptcha: 'google'
                }));
            });
        }
    };

    handleShow = () => {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    handleClose = () => {
        this.setState({ show: false, effect: 'zoomOut', disabled: false, submitted: false, ruleChecked: false, ruleChecked18: false });
    }

    verifyRefrelCode = async () => {
        try {

            const response = await axios.get(`https://api.trubetx.com/verify-referral-code/${this.state.referral}`)
            console.log("response comes like", response)

            return response?.data?.valid;

        } catch (error) {
            console.log("error", error)
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submitted: true });

        const {
            username,
            email,
            phone,
            password,
            confirmPassword,
            ruleChecked,
            referral,
            ruleChecked18
        } = this.state;

        // ❌ Validation (no loading yet)
        if (!phone) {
            sendNotfication('Please enter a phone number', 'error', 'bottom-left');
            return;
        }

        if (isNaN(phone) || phone.length < 10 || phone.length > 15) {
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            return;
        }

        if (!username) {
            sendNotfication('Please enter a username', 'error', 'bottom-left');
            return;
        }

        if (username.length < 5) {
            sendNotfication('Please enter username more than 5 words', 'error', 'bottom-left');
            return;
        }

        if (!password || !confirmPassword) {
            sendNotfication('Please enter password and confirm password', 'error', 'bottom-left');
            return;
        }

        if (password !== confirmPassword) {
            sendNotfication('Passwords do not match', 'error', 'bottom-left');
            return;
        }

        if (!ruleChecked18) {
            sendNotfication('You must be at least 18 years old to continue', 'error', 'bottom-left');
            return;
        }

        if (!ruleChecked) {
            sendNotfication('Please agree to the terms and conditions', 'error', 'bottom-left');
            return;
        }

        // ✅ Referral check
        if (referral && referral.trim() !== "") {
            const verified = await this.verifyRefrelCode();
            if (!verified) {
                sendNotfication('Please enter a valid referral code', 'error', 'bottom-left');
                return;
            }
        }

        // ✅ NOW start loading
        this.setState({ isLoading: true });

        function randomEmail() {
            const domains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com"];
            const randomString = Math.random().toString(36).substring(2, 10);
            const randomDomain = domains[Math.floor(Math.random() * domains.length)];
            return `${randomString}@${randomDomain}`;
        }

        socket.emit(
            C.REGISTER_USER,
            encode({
                countryCode: this.state.countryCode,
                phone,
                username,
                password,
                email: email || randomEmail(),
                method: true,
                refree: referral || '',
                aff: storage.getKey('aff') || null
            })
        );
    };


    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    checkRule = () => {
        this.setState(prevState => ({ ruleChecked: !prevState.ruleChecked }));
    }
    checkRule18 = () => {
        this.setState(prevState => ({ ruleChecked18: !prevState.ruleChecked18 }));
    }

    login = () => {
        this.handleClose();
        Event.emit('login_form');
    }

    handleSendOtp = async () => {
        const { phone } = this.state;

        if (!phone) {
            sendNotfication('Please enter a phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        if (isNaN(phone)) {
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        if (phone.length < 10 || phone.length > 15) {
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        this.setState({
            loading: true
        })
        try {
            const response = await fetch(`https://api.trubetx.com/send-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ phone: phone, countryCode: this.state.countryCode, type: 'forget' })
            });

            const data = await response.json();

            this.setState({
                loading: false
            })

            if (data.status) {
                console.log(data);
                this.setState({ isOtp: true });
                sendNotfication('OTP sent successfully!', 'success', 'bottom-left');
            } else {
                sendNotfication(data.message || "Failed to send OTP", 'error', 'bottom-left');
            }
        } catch (err) {
            console.error("Error sending OTP:", err);
            alert("Something went wrong while sending OTP");
        }
    };


    render() {
        const { show, username, phone, email, password, confirmPassword, ruleChecked, disabled, referral, ruleChecked18, isOtp, otp, loading } = this.state;

        return (
            <>
                {storage.getKey('logged') ? false : <StyledSignUpButton onClick={this.handleShow} className='button-brand game-fonts'>
                    Sign up
                </StyledSignUpButton>}

                <StyledModal
                    size="md"
                    centered
                    show={storage.getKey('logged') ? false : show}
                    onHide={this.handleClose}
                    aria-labelledby="register-modal"
                    className={`animated ${this.state.effect}`}
                >

                    <div className='login-main'>
                        <div className='login-left'>
                            <img className='login-top-img' src='\assets\bcimages\login\login-top-img.webp' />
                            <img className='login-top-img-2' src='\assets\bcimages\login\login-banner-2.webp' />
                            <img className='login-logo-img' src={process.env.REACT_APP_LG_LOGO} />
                            <CloseButtonNew onClick={this.handleClose}>×</CloseButtonNew>
                            <div className='login-content'>
                                <p className='login-content-title'>Stay Untamed</p>
                                <p className='login-content-desc'>Sign Up & Get Welcome Bonus</p>
                            </div>
                        </div>

                        <div className='login-right'>
                            <ModalHeader>
                                <p className='signin-text-header'>Sign up</p>
                                <CloseButton onClick={this.handleClose}>×</CloseButton>
                            </ModalHeader>
                            <ModalBody>

                                <StyledForm onSubmit={this.handleSubmit}>



                                    <PhoneInputWrapper>

                                        <select
                                            value={this.state.countryCode}
                                            onChange={(e) => this.setState({ countryCode: e.target.value })}
                                            style={{
                                                padding: "8px",
                                                borderRadius: "6px",
                                                border: "1px solid #555",
                                                background: "#1a1a1a",
                                                color: "#fff"
                                            }}
                                        >
                                            {/* <option value="+91">🇮🇳 +91</option> */}
                                            {this.state.countryCodeData.map((country) => (
                                                <option key={country.code} value={country.dial_code}>{country?.flag}{country.dial_code}
                                                </option>
                                            ))}
                                        </select>

                                        <StyledInputss
                                            type="text"
                                            name="phone"
                                            value={phone}
                                            onChange={this.handleInputChange}
                                            placeholder="Phone Number"
                                        />

                                        {/* <SendOtpButton type="button" onClick={this.handleSendOtp} disabled={loading}>
                                            {loading ? "Sending..." : "  Send OTP"}
                                        </SendOtpButton> */}
                                    </PhoneInputWrapper>

                                    {/* {isOtp && (
                                        <StyledInput
                                            type="text"
                                            name="otp"
                                            value={otp}
                                            onChange={this.handleInputChange}
                                            placeholder="Enter OTP"
                                        />
                                    )} */}




                                    <StyledInput
                                        type="text"
                                        name="username"
                                        value={username}
                                        onChange={this.handleInputChange}
                                        placeholder="Username"
                                    />

                                    {/* <StyledInput
                                type="email"
                                name="email"
                                value={email}
                                onChange={this.handleInputChange}
                                placeholder="Email Address"
                            /> */}

                                    <StyledInput
                                        type="password"
                                        name="password"
                                        value={password}
                                        onChange={this.handleInputChange}
                                        placeholder="Password"
                                    />
                                    <StyledInput
                                        type="password"
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={this.handleInputChange}
                                        placeholder="Confirm password"
                                    />

                                    <StyledInput
                                        name="referral"
                                        value={referral}
                                        onChange={this.handleInputChange}
                                        placeholder="Referral Code"
                                    />

                                    <div>
                                        <input
                                            type="checkbox"
                                            id="ruleCheck18"
                                            checked={ruleChecked18}
                                            onChange={this.checkRule18}
                                        />
                                        <label className='checkbox-signup' htmlFor="ruleCheck18" style={{ marginLeft: '10px' }}>
                                            I agree &amp; confirm I am at least 18 years old
                                        </label>
                                    </div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            id="ruleCheckTerms"
                                            checked={ruleChecked}
                                            onChange={this.checkRule}
                                        />
                                        <label className='checkbox-signup' htmlFor="ruleCheckTerms" style={{ marginLeft: '10px' }}>
                                            I agree with the user agreement
                                        </label>
                                    </div>
                                    <SignUpButton type="submit" disabled={this.state.isLoading}>
                                        {this.state.isLoading && (
                                            <span
                                                className="spinner-grow spinner-grow-sm mr-1"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        )}
                                        Sign Up
                                    </SignUpButton>

                                    <div className="signup-button">
                                        Already have an account?
                                        <SignInButton ><Link to={"/login"}>Sign In</Link></SignInButton>
                                    </div>
                                </StyledForm>
                            </ModalBody>
                        </div>
                    </div>
                </StyledModal>
            </>
        );
    }
}

export default NewRegister;

